import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Controller } from "react-hook-form";
import { Control } from "react-hook-form/dist/types/form";
import {
  faCheckCircle,
  faExclamationCircle,
} from "@fortawesome/pro-solid-svg-icons";
import TooltipNew from "../common/TooltipNew";
import { LabelContainer } from "./dynamic/SelectNewTextField";
import {
  StyledInput,
  StyledLabel,
  TextFieldWrapper,
  WarnLabel,
} from "./TextFieldController";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { useTheme } from "styled-components";

export interface CurrencyInputProps {
  control: Control<any>;
  rules?: {
    required?: boolean;
    minLength?: number;
    maxLength?: number;
    pattern?: RegExp;
    valueAsNumber?: boolean;
    validate?: any;
  };
  placeholder?: string;
  defaultValue: string | number | null | undefined;
  label?: string;
  fieldName: string;
  errorMessage?: string;
  small?: boolean;
  maxWidth?: boolean;
  tooltip?: string;
  disabled?: boolean;
  german?: boolean;
  className?: string;
}

const CurrencyInput = (props: CurrencyInputProps): JSX.Element => {
  const theme = useTheme();
  return (
    <Controller
      name={props.fieldName}
      control={props.control}
      defaultValue={props.defaultValue || "0"}
      rules={props.rules}
      render={({
        field: { onChange, onBlur, value, name, ref },
        fieldState: { invalid, isDirty, error, isTouched },
      }) => {
        const changeValue = (e: React.ChangeEvent<HTMLInputElement>) => {
          const newValue: string = e.target.value;
          if (!/^\d+$/.test(newValue.replace(",", "")) && newValue !== "") {
            return value;
          }
          if (newValue.replace(/[^,]/g, "").length > 1) {
            return value;
          }
          if (
            newValue.includes(",") &&
            newValue.indexOf(",") < newValue.length - 3
          ) {
            return value;
          }
          if (newValue.length > 10) {
            return value;
          }
          if (props.german) return onChange(newValue);
          return onChange(newValue.replace(",", "."));
        };

        return (
          <TextFieldWrapper responsive className={props.className}>
            {props.label ? (
              <StyledLabel responsive>
                <LabelContainer>
                  <label>{props.label}</label>
                  &nbsp;
                  {props.tooltip ? (
                    <TooltipNew message={props.tooltip} />
                  ) : (
                    <></>
                  )}
                  {!invalid && isDirty && isTouched ? (
                    <>
                      &nbsp;
                      <FontAwesomeIcon
                        icon={faCheckCircle as IconProp}
                        color={theme.colors.accent7}
                      />
                    </>
                  ) : (
                    <></>
                  )}
                  {(invalid && isDirty) || error ? (
                    <>
                      &nbsp;
                      <FontAwesomeIcon
                        icon={faExclamationCircle as IconProp}
                        color={theme.colors.accent1}
                      />
                    </>
                  ) : (
                    <></>
                  )}
                </LabelContainer>
              </StyledLabel>
            ) : (
              <></>
            )}
            <StyledInput
              responsive
              maxWidth={props.maxWidth}
              error={error !== undefined}
              key={name}
              onBlur={onBlur}
              onChange={(e) => changeValue(e)}
              ref={ref}
              disabled={props.disabled}
              value={value.replace(".", ",")}
              type={"text"}
              inputMode={"decimal"}
              placeholder={props.placeholder ? props.placeholder : props.label}
            />
            {error ? (
              <WarnLabel>
                {props.errorMessage ? props.errorMessage : error?.message}
              </WarnLabel>
            ) : null}
          </TextFieldWrapper>
        );
      }}
    />
  );
};

export default CurrencyInput;
